import { useSelector } from 'react-redux'

import { bookSubtitleSelector, bookTitleSelector } from '@/selectors'

const BookTitle = () => {
  const bookTitle = useSelector(bookTitleSelector)
  const bookSubtitle = useSelector(bookSubtitleSelector)

  return (
    <h3 className='section-subtitle-heading mb-3 line-height-2'>
      <Choose>
        <When condition={bookSubtitle}>
          {bookTitle}
          <br />
          {bookSubtitle}
        </When>
        <Otherwise>
          {bookTitle}
        </Otherwise>
      </Choose>
    </h3>
  )
}

export default BookTitle
